import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["tabindex", "id", "aria-expanded", "aria-owns", "aria-activedescendant", "aria-disabled"]
const _hoisted_2 = {
  class: "customSelectWrapper",
  role: "presentation"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "​", -1)
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "d-none",
  type: "text",
  ref: "validationInput"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadedOrPlaceholder = _resolveComponent("LoadedOrPlaceholder")!
  const _component_TreeView = _resolveComponent("TreeView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _mergeProps({
      role: "combobox",
      class: ["form-select customSelectSelect cdesTreeSelect", { 'is-invalid': _ctx.wasValidated && _ctx.validationError !== _ctx.ValidationError.NONE }],
      tabindex: _ctx.disabled ? null : '0',
      onKeydown: [
        _cache[0] || (_cache[0] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.next() : this.show()), ["stop","prevent"]), ["arrow-down"])),
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.prev() : this.show()), ["stop","prevent"]), ["arrow-up"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.up() : null), ["stop","prevent"]), ["arrow-left"])),
        _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.down() : null), ["stop","prevent"]), ["arrow-right"])),
        _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.selectFirst() : null), ["stop","prevent"]), ["home"])),
        _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.selectLast() : null), ["stop","prevent"]), ["end"])),
        _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (this.show()), ["stop","prevent"]), ["space"])),
        _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.activate() : null), ["stop","prevent"]), ["enter"])),
        _cache[8] || (_cache[8] = _withKeys(_withModifiers(($event: any) => (this.hide()), ["stop","prevent"]), ["escape"])),
        _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (this.expanded ? this.$refs.dropdown.expandSiblings() : null), ["stop","prevent"]), ["*"]))
      ],
      id: _ctx.selectId,
      "aria-expanded": _ctx.expanded ? 'true' : 'false',
      "aria-owns": _ctx.$id('dropdown'),
      "aria-activedescendant": _ctx.selectedId,
      "aria-autocomplete": "none",
      ref: "select",
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.toggle())),
      onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.hide()))
    }, _ctx.$attrs, {
      "aria-disabled": _ctx.disabled ? 'true' : 'false',
      "aria-haspopup": "tree"
    }), [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _renderSlot(_ctx.$slots, "default", {
          main: true,
          data: _ctx.selectedData
        }, () => [
          _createTextVNode(_toDisplayString(_ctx.model.getLabel(_ctx.selectedData)), 1)
        ])
      ])
    ], 16, _hoisted_1),
    _createVNode(_component_TreeView, {
      id: _ctx.$id('dropdown'),
      class: "customSelectDropdown dropdown-menu cdesTreeSelectDropdown",
      ref: "dropdown",
      tabindex: "-1",
      onMousedown: _cache[12] || (_cache[12] = _withModifiers(() => {}, ["prevent"])),
      model: _ctx.model,
      selectedKey: _ctx.value,
      "onUpdate:selectedKey": [
        _cache[13] || (_cache[13] = ($event: any) => ((_ctx.value) = $event)),
        _cache[14] || (_cache[14] = ($event: any) => (this.hide()))
      ],
      "onUpdate:focusedId": _cache[15] || (_cache[15] = ($event: any) => (_ctx.selectedId = $event)),
      "onUpdate:selectedData": _cache[16] || (_cache[16] = ($event: any) => (_ctx.selectedData = $event)),
      customItemClass: "cdesTreeSelectItem",
      customItemLabelClass: ({ selected, focused }) => [{ 'active': selected, 'focus': focused }, 'cdesTreeSelectItemLabel'],
      focusable: false
    }, {
      default: _withCtx((props) => [
        _createElementVNode("span", {
          class: "cdesTreeSelectIcon",
          onClick: ($event: any) => {if (props.group) { props.focus(); props.toggle(); $event.stopPropagation(); $event.preventDefault(); }}
        }, null, 8, _hoisted_4),
        _renderSlot(_ctx.$slots, "default", _mergeProps({ main: false }, props), () => [
          _createVNode(_component_LoadedOrPlaceholder, {
            value: props.data
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.model.getLabel(props.data)), 1)
            ]),
            _: 2
          }, 1032, ["value"])
        ])
      ]),
      _: 3
    }, 8, ["id", "model", "selectedKey", "customItemLabelClass"]),
    _createElementVNode("input", _hoisted_5, null, 512)
  ], 64))
}